import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=7ab54d3e&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=7ab54d3e&prod&lang=scss&scoped=true"
import style1 from "./Message.vue?vue&type=style&index=1&id=7ab54d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab54d3e",
  null
  
)

export default component.exports